import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appDataTableHeader]',
  standalone: true,
})
export class DataTableHeaderDirective {
  public readonly templateRef = inject(TemplateRef);
}
